import { Pipe, PipeTransform } from "@angular/core";
import differenceInMinutes from "date-fns/differenceInMinutes";

@Pipe({
    name: "differenceInMinutes",
})
export class DifferenceInMinutesFnsPipe implements PipeTransform {
    transform(dateOne: string, dateTwo: string): any {
        return differenceInMinutes(new Date(dateTwo), new Date(dateOne));
    }
}
